import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "text-center p-4"
}
const _hoisted_11 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_12 = {
  key: 2,
  class: "row mb-4"
}
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = {
  key: 3,
  class: "kyts-container"
}
const _hoisted_20 = {
  key: 0,
  class: "parent-photos-section mb-4"
}
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "parent-photos-gallery" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["src", "alt"]
const _hoisted_26 = { class: "parent-photo-number" }
const _hoisted_27 = { class: "row mb-4" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = { class: "card bg-primary text-white" }
const _hoisted_30 = { class: "card-body text-center" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "card bg-success text-white" }
const _hoisted_34 = { class: "card-body text-center" }
const _hoisted_35 = { class: "card-title" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "card bg-warning text-white" }
const _hoisted_38 = { class: "card-body text-center" }
const _hoisted_39 = { class: "card-title" }
const _hoisted_40 = { class: "table-responsive" }
const _hoisted_41 = { class: "table table-hover table-striped" }
const _hoisted_42 = ["rowspan"]
const _hoisted_43 = { class: "employee-info" }
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = ["rowspan"]
const _hoisted_46 = { class: "badge badge-info" }
const _hoisted_47 = ["rowspan"]
const _hoisted_48 = ["rowspan"]
const _hoisted_49 = ["rowspan"]
const _hoisted_50 = { class: "status-info" }
const _hoisted_51 = { class: "category-info" }
const _hoisted_52 = { class: "mb-1" }
const _hoisted_53 = { class: "badge badge-secondary badge-sm" }
const _hoisted_54 = { class: "ml-2" }
const _hoisted_55 = { class: "mb-2" }
const _hoisted_56 = { class: "mb-1" }
const _hoisted_57 = { class: "mb-0 text-muted small" }
const _hoisted_58 = { class: "mb-1" }
const _hoisted_59 = { class: "mb-0 text-muted small" }
const _hoisted_60 = { class: "mt-1" }
const _hoisted_61 = { class: "text-info" }
const _hoisted_62 = { class: "assignments-compact" }
const _hoisted_63 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_64 = { class: "assignment-employee" }
const _hoisted_65 = { class: "text-muted" }
const _hoisted_66 = { class: "assignment-badges" }
const _hoisted_67 = {
  key: 0,
  class: "badge badge-xs badge-info"
}
const _hoisted_68 = {
  key: 1,
  class: "badge badge-xs badge-primary"
}
const _hoisted_69 = {
  key: 2,
  class: "badge badge-xs badge-danger"
}
const _hoisted_70 = {
  key: 0,
  class: "completion-time mt-1"
}
const _hoisted_71 = { class: "text-success" }
const _hoisted_72 = {
  key: 1,
  class: "work-notes mt-1"
}
const _hoisted_73 = { class: "text-info" }
const _hoisted_74 = {
  key: 2,
  class: "assignment-photos mt-1"
}
const _hoisted_75 = { class: "photos-header mb-1" }
const _hoisted_76 = { class: "text-primary" }
const _hoisted_77 = { class: "photos-gallery d-flex flex-wrap" }
const _hoisted_78 = ["src", "alt", "onClick"]
const _hoisted_79 = { class: "penalties-overview" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { class: "penalties-summary mb-2" }
const _hoisted_82 = { class: "badge badge-danger badge-sm mr-1" }
const _hoisted_83 = {
  key: 0,
  class: "badge badge-warning badge-sm"
}
const _hoisted_84 = { class: "penalties-brief" }
const _hoisted_85 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_86 = {
  key: 0,
  class: "text-center mt-1"
}
const _hoisted_87 = { class: "text-muted" }
const _hoisted_88 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = ["onClick"]
const _hoisted_91 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_92 = {
  key: 1,
  class: "pagination-wrapper mt-4"
}
const _hoisted_93 = { class: "pagination justify-content-center" }
const _hoisted_94 = { class: "page-item active" }
const _hoisted_95 = {
  class: "page-link",
  href: "#"
}
const _hoisted_96 = {
  key: 4,
  class: "text-center p-5"
}
const _hoisted_97 = { class: "image-modal-header" }
const _hoisted_98 = { class: "modal-title" }
const _hoisted_99 = { class: "image-modal-body" }
const _hoisted_100 = ["src", "alt"]
const _hoisted_101 = { class: "image-modal-footer" }
const _hoisted_102 = ["href"]
const _hoisted_103 = { class: "penalties-modal-body" }
const _hoisted_104 = { class: "penalties-list" }
const _hoisted_105 = { class: "penalty-header" }
const _hoisted_106 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_107 = { class: "mb-1" }
const _hoisted_108 = { class: "text-muted" }
const _hoisted_109 = { class: "penalty-badges" }
const _hoisted_110 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_111 = { class: "penalty-content mt-3" }
const _hoisted_112 = {
  key: 0,
  class: "penalty-media mb-3"
}
const _hoisted_113 = { class: "media-gallery" }
const _hoisted_114 = { class: "media-item" }
const _hoisted_115 = ["src", "alt", "onClick"]
const _hoisted_116 = {
  key: 1,
  class: "penalty-media mb-3"
}
const _hoisted_117 = { class: "media-gallery" }
const _hoisted_118 = { class: "media-item" }
const _hoisted_119 = ["src", "alt", "onClick"]
const _hoisted_120 = {
  key: 2,
  class: "penalty-media mb-3"
}
const _hoisted_121 = { class: "media-title" }
const _hoisted_122 = { class: "media-gallery" }
const _hoisted_123 = ["src", "alt", "onClick"]

import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

// Type definitions
interface Employee {
  employeeId: string
  employeeName: string
  employeeCode: string
}

interface Site {
  siteId: string
  siteName: string
  siteAddress: string
  siteUID: string
}

interface Assignment {
  _id: string
  assignmentId: string
  subCategoryLogNo: string
  parentLogNo: string
  kytOperationId: string
  employee: Employee
  employeeName: string
  employeeCode: string
  subCategory: {
    subCategoryId: string
    name: string
    description: string
  }
  assignedDate: string
  penalty: number
  priority: string
  photos: any[]
  isCompletedWork: boolean
  workStarted: boolean
  workCompletedAt?: string
  isVerified: boolean
  isSubmit: boolean
  requiresRework: boolean
  workNotes?: string
  statusHistory: any[]
  lastUpdated: string
  cascadeInfo: {
    originalLogNo: string
    totalOriginalAssignees: number
    completedInPreviousKyts: number
    remainingAssignees: number
    cascadeGeneration: number
  }
  createdAt: string
  updatedAt: string
}

interface PenaltyWarning {
  employeeId: string
  employeeName: string
  action: string
  penalty: number
  penaltyAmount: number
  slip: string
  actionDate: string
  actionTime: string
  isCompletedWork: boolean
  workStarted: boolean
  isVerified: boolean
  isSubmit: boolean
  uploadPhoto: string
  photos: any[]
  assignmentId?: string
}

interface CategoryData {
  category: string
  subCategory: string
  problem: string
  solution: string
  logNo: string
  status: string
  completionPercentage: number
  totalAssignments: number
  completedAssignments: number
  assignedPenaltiesWarnings?: PenaltyWarning[]
  employeeAssignments: Assignment[]
}

interface KytPenaltiesWarnings {
  totalActions: number
  warnings: number
  penalties: number
  totalPenaltyAmount: number
  actionsList: {
    category: string
    subCategory: string
    employeeName: string
    action: string
    penalty: number
    penaltyAmount: number
    slip: string
    actionDate: string
    actionTime: string
    logNo: string
  }[]
  actionsSummary: {
    [key: string]: number
  }
}

interface ChildKyt {
  _id: string
  mainLogNo: string
  siteName: string
  nfd: string
  previousNfd?: string | null
  status: string
  kytStatus: string
  createdAt: string
  employee: Employee
  kytPenaltiesWarnings?: KytPenaltiesWarnings | null
  employeePenaltyWarnings?: PenaltyWarning[] | null
  site: Site
  categoryData: CategoryData[]
}

interface Pagination {
  currentPage: number
  totalPages: number
  totalKyts: number
  hasNext: boolean
  hasPrev: boolean
  limit: number
  skip: number
}

interface ParentKyt {
  _id: string
  mainLogNo: string
  parentMainLogNo: string
  siteName: string
  nfd: string
  status: string
  kytStatus: string
  createdAt: string
  employee: Employee
  site: Site
  photos?: string[]
  totalPhotos?: number
}

interface KytData {
  parentMainLogNo: string
  totalChildKyts: number
  parentKyt?: ParentKyt
  childKyts: ChildKyt[]
  pagination: Pagination
}

// Reactive data

export default /*@__PURE__*/_defineComponent({
  __name: 'kyts-by-log',
  setup(__props) {

const kytData = ref<KytData | null>(null)
const loading = ref(false)
const error = ref('')
const searchTerm = ref('')
const statusFilter = ref('')
const priorityFilter = ref('')
const selectedImage = ref('')
const selectedImageTitle = ref('')
const selectedPenalties = ref<PenaltyWarning[] | null>(null)
const route = useRoute()

// Sample data based on your API response
const sampleData = {
  "success": true,
  "message": "Child KYTs with logNo retrieved successfully",
  "data": {
    "parentMainLogNo": "MLYHLWTXN1",
    "totalChildKyts": 2,
    "childKyts": [
      {
        "_id": "68c3e9faefce898880bb7d0d",
        "mainLogNo": "MLYHLWTXN1",
        "siteName": "Agil Glass Industries Pvt Ltd Plot No125A",
        "nfd": "2025-09-16",
        "status": "open",
        "createdAt": "2025-09-12T09:38:02.667Z",
        "employee": {
          "employeeId": "677ce932cf46ce38e9f43c28",
          "employeeName": "Test Employee",
          "employeeCode": "OPE01"
        },
        "site": {
          "siteId": "67a6f25a602f7c3ecd3ad1b7",
          "siteName": "Agil Glass Industries Pvt Ltd Plot No125A",
          "siteAddress": "Sed aut ad sunt volu",
          "siteUID": "SMS-0002"
        },
        "categoryData": [
          {
            "category": "manpower",
            "subCategory": "testing manpower 2",
            "problem": "the problem of testing manpower 2",
            "solution": "new solution",
            "logNo": "LDGAU4YQ",
            "status": "pending",
            "completionPercentage": 0,
            "totalAssignments": 2,
            "completedAssignments": 0,
            "employeeAssignments": [
              {
                "_id": "68c3e9fbefce898880bb7d1d",
                "assignmentId": "ASSIGN-20250912-0122",
                "subCategoryLogNo": "SUBCAT-20250912-0122",
                "parentLogNo": "LDGAU4YQ",
                "kytOperationId": "68c3e9faefce898880bb7d0d",
                "employee": {
                  "employeeId": "67ab4d0acffb60970f45bb84",
                  "employeeName": "Rahul Chakraborty",
                  "employeeCode": "MKT04"
                },
                "employeeName": "Rahul Chakraborty",
                "employeeCode": "MKT04",
                "subCategory": {
                  "subCategoryId": "6768677b2acfac15485c6e3a",
                  "name": "testing manpower 2",
                  "description": " "
                },
                "assignedDate": "2025-09-12T09:38:03.254Z",
                "penalty": 0,
                "priority": "medium",
                "photos": [],
                "isCompletedWork": false,
                "workStarted": false,
                "isVerified": false,
                "isSubmit": false,
                "requiresRework": false,
                "statusHistory": [],
                "lastUpdated": "2025-09-12T09:38:03.254Z",
                "cascadeInfo": {
                  "originalLogNo": "LDGAU4YQ",
                  "totalOriginalAssignees": 2,
                  "completedInPreviousKyts": 0,
                  "remainingAssignees": 2,
                  "cascadeGeneration": 1
                },
                "createdAt": "2025-09-12T09:38:03.255Z",
                "updatedAt": "2025-09-12T09:38:03.255Z"
              },
              {
                "_id": "68c3e9fbefce898880bb7d20",
                "assignmentId": "ASSIGN-20250912-0123",
                "subCategoryLogNo": "SUBCAT-20250912-0122",
                "parentLogNo": "LDGAU4YQ",
                "kytOperationId": "68c3e9faefce898880bb7d0d",
                "employee": {
                  "employeeId": "679b57edb51d4a3e357a1274",
                  "employeeName": "Test Employee 2",
                  "employeeCode": "EMP02"
                },
                "employeeName": "Test Employee 2",
                "employeeCode": "EMP02",
                "subCategory": {
                  "subCategoryId": "6768677b2acfac15485c6e3a",
                  "name": "testing manpower 2",
                  "description": " "
                },
                "assignedDate": "2025-09-12T09:38:03.376Z",
                "penalty": 0,
                "priority": "medium",
                "photos": [],
                "isCompletedWork": false,
                "workStarted": false,
                "isVerified": false,
                "isSubmit": false,
                "requiresRework": false,
                "statusHistory": [],
                "lastUpdated": "2025-09-12T09:38:03.376Z",
                "cascadeInfo": {
                  "originalLogNo": "LDGAU4YQ",
                  "totalOriginalAssignees": 2,
                  "completedInPreviousKyts": 0,
                  "remainingAssignees": 2,
                  "cascadeGeneration": 1
                },
                "createdAt": "2025-09-12T09:38:03.376Z",
                "updatedAt": "2025-09-12T09:38:03.376Z"
              }
            ]
          }
        ]
      },
      {
        "_id": "68c3ebfef12a1262e740135a",
        "mainLogNo": "MLYHLWTXN1",
        "siteName": "Agil Glass Industries Pvt Ltd Plot No125A",
        "nfd": "2025-09-19",
        "status": "open",
        "createdAt": "2025-09-12T09:46:38.680Z",
        "employee": {
          "employeeId": "677ce932cf46ce38e9f43c28",
          "employeeName": "Test Employee",
          "employeeCode": "OPE01"
        },
        "site": {
          "siteId": "67a6f25a602f7c3ecd3ad1b7",
          "siteName": "Agil Glass Industries Pvt Ltd Plot No125A",
          "siteAddress": "Sed aut ad sunt volu",
          "siteUID": "SMS-0002"
        },
        "categoryData": [
          {
            "category": "manpower",
            "subCategory": "testing manpower 2",
            "problem": "the problem of testing manpower 2",
            "solution": "this is the main work solutvbbion",
            "logNo": "TTW4KZRR",
            "status": "pending",
            "completionPercentage": 0,
            "totalAssignments": 1,
            "completedAssignments": 1,
            "employeeAssignments": [
              {
                "_id": "68c3ebfff12a1262e740136d",
                "assignmentId": "ASSIGN-20250912-0124",
                "subCategoryLogNo": "SUBCAT-20250912-0123",
                "parentLogNo": "TTW4KZRR",
                "kytOperationId": "68c3ebfef12a1262e740135a",
                "employee": {
                  "employeeId": "679b57edb51d4a3e357a1274",
                  "employeeName": "Test Employee 2",
                  "employeeCode": "EMP02"
                },
                "employeeName": "Test Employee 2",
                "employeeCode": "EMP02",
                "subCategory": {
                  "subCategoryId": "6768677b2acfac15485c6e3a",
                  "name": "testing manpower 2",
                  "description": " "
                },
                "assignedDate": "2025-09-12T09:46:39.444Z",
                "penalty": 0,
                "priority": "medium",
                "photos": [],
                "isCompletedWork": true,
                "workStarted": false,
                "workCompletedAt": "2025-09-12T09:46:52.541Z",
                "isVerified": false,
                "isSubmit": false,
                "requiresRework": false,
                "workNotes": "xbxbxbx",
                "statusHistory": [
                  {
                    "status": "work-completed",
                    "changedAt": "2025-09-12T09:46:52.183Z",
                    "reason": "Work marked as completed",
                    "_id": "68c3ec0cf12a1262e74013a7"
                  }
                ],
                "lastUpdated": "2025-09-12T09:46:52.183Z",
                "cascadeInfo": {
                  "originalLogNo": "TTW4KZRR",
                  "totalOriginalAssignees": 1,
                  "completedInPreviousKyts": 0,
                  "remainingAssignees": 1,
                  "cascadeGeneration": 1
                },
                "createdAt": "2025-09-12T09:46:39.446Z",
                "updatedAt": "2025-09-12T09:46:52.185Z"
              }
            ]
          }
        ]
      }
    ],
    "pagination": {
      "currentPage": 1,
      "totalPages": 1,
      "totalKyts": 2,
      "hasNext": false,
      "hasPrev": false,
      "limit": 50,
      "skip": 0
    }
  }
}

// Computed properties
const sortedKyts = computed(() => {
  if (!kytData.value?.childKyts) return []
  
  let filtered = [...kytData.value.childKyts]
  
  // Filter by search term
  if (searchTerm.value) {
    const search = searchTerm.value.toLowerCase()
    filtered = filtered.filter(kyt => 
      kyt.siteName.toLowerCase().includes(search) ||
      kyt.employee.employeeName.toLowerCase().includes(search) ||
      kyt.categoryData.some(cat => 
        cat.category.toLowerCase().includes(search) ||
        cat.subCategory.toLowerCase().includes(search)
      )
    )
  }
  
  // Filter by status
  if (statusFilter.value) {
    filtered = filtered.filter(kyt => kyt.kytStatus === statusFilter.value)
  }
  
  // Filter by priority (check assignments)
  if (priorityFilter.value) {
    filtered = filtered.filter(kyt => 
      kyt.categoryData.some(cat =>
        cat.employeeAssignments.some(assignment =>
          assignment.priority === priorityFilter.value
        )
      )
    )
  }
  
  // Sort by creation date, latest first
  return filtered.sort((a, b) => {
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  })
})

// Methods
const fetchKytData = async (logNo: string) => {
  loading.value = true
  error.value = ''
  
  try {
    const response = await fetch(`http://localhost:5020/api/main-logs/parent/${logNo}/kyts-with-logno`)
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    
    const result = await response.json()
    
    if (result.success) {
      kytData.value = result.data
    } else {
      throw new Error(result.message || 'Failed to fetch data')
    }
    
  } catch (err: any) {
    error.value = err.message || 'Failed to fetch KYT data. Please try again.'
    console.error('Error fetching KYT data:', err)
  } finally {
    loading.value = false
  }
}

const getStatusBadgeClass = (status: string) => {
  switch (status?.toLowerCase()) {
    case 'completed':
      return 'badge-success'
    case 'approved':
      return 'badge-warning' // Changed to warning for pending display
    case 'closed':
      return 'badge-success'
    case 'open':
      return 'badge-primary'
    case 'pending':
      return 'badge-warning'
    case 'in-progress':
    case 'started':
      return 'badge-info'
    case 'cancelled':
    case 'rejected':
      return 'badge-danger'
    default:
      return 'badge-secondary'
  }
}

const getDisplayStatus = (status: string) => {
  if (status?.toLowerCase() === 'approved') {
    return 'PENDING'
  }
  return status?.toUpperCase()
}

const getActionBadgeClass = (action: string) => {
  switch (action?.toLowerCase()) {
    case 'penalty':
      return 'badge-danger'
    case 'warning':
      return 'badge-warning'
    case 'change':
      return 'badge-info'
    case 'note':
      return 'badge-secondary'
    default:
      return 'badge-light'
  }
}

const getPriorityBadgeClass = (priority: string) => {
  switch (priority?.toLowerCase()) {
    case 'high':
      return 'badge-danger'
    case 'medium':
      return 'badge-warning'
    case 'low':
      return 'badge-info'
    default:
      return 'badge-secondary'
  }
}

const getSubCategoryName = (category: CategoryData, kyt: ChildKyt) => {
  // First try to get from category.subCategory if it's a string name
  if (typeof category.subCategory === 'string' && !category.subCategory.match(/^[0-9a-fA-F]{24}$/)) {
    return category.subCategory
  }
  
  // Try to get from employee assignments
  const firstAssignment = category.employeeAssignments?.[0]
  if (firstAssignment?.subCategory?.name) {
    return firstAssignment.subCategory.name
  }
  
  // Fallback to the original subCategory value
  return category.subCategory || 'Unknown'
}

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString()
}

const formatDateTime = (dateString: string) => {
  return new Date(dateString).toLocaleString()
}

const getCompletedKyts = () => {
  if (!kytData.value?.childKyts) return 0
  
  // Count categories that are completed or closed
  let completedCount = 0
  kytData.value.childKyts.forEach(kyt => {
    kyt.categoryData.forEach(category => {
      if (category.status === 'completed' || category.status === 'closed' || category.completionPercentage === 100) {
        completedCount++
      }
    })
  })
  return completedCount
}

const getPendingKyts = () => {
  if (!kytData.value?.childKyts) return 0
  
  // Count categories that are not completed
  let pendingCount = 0
  kytData.value.childKyts.forEach(kyt => {
    kyt.categoryData.forEach(category => {
      if (category.status !== 'completed' && category.status !== 'closed' && category.completionPercentage < 100) {
        pendingCount++
      }
    })
  })
  return pendingCount
}

const getTotalCategories = () => {
  if (!kytData.value?.childKyts) return 0
  
  let totalCount = 0
  kytData.value.childKyts.forEach(kyt => {
    totalCount += kyt.categoryData.length
  })
  return totalCount
}

const getTotalPenaltyAmount = (penalties: PenaltyWarning[]) => {
  if (!penalties || penalties.length === 0) return 0
  
  return penalties.reduce((total, penalty) => {
    return total + (penalty.penaltyAmount || 0)
  }, 0)
}

const changePage = (page: number) => {
  // Implement pagination logic here
  console.log('Change to page:', page)
}

const refreshData = () => {
  const logNo = Array.isArray(route.params.logNo) ? route.params.logNo[0] : route.params.logNo || 'MLYHLWTXN1'
  fetchKytData(logNo)
}

// Image modal methods
const openImageModal = (imageUrl: string, title: string) => {
  selectedImage.value = imageUrl
  selectedImageTitle.value = title
  // Prevent body scrolling when modal is open
  document.body.style.overflow = 'hidden'
}

const closeImageModal = () => {
  selectedImage.value = ''
  selectedImageTitle.value = ''
  // Restore body scrolling
  document.body.style.overflow = 'auto'
}

// Penalties modal methods
const openPenaltiesModal = (category: CategoryData) => {
  selectedPenalties.value = category.assignedPenaltiesWarnings || null
  // Prevent body scrolling when modal is open
  document.body.style.overflow = 'hidden'
}

const closePenaltiesModal = () => {
  selectedPenalties.value = null
  // Restore body scrolling
  document.body.style.overflow = 'auto'
}

// Lifecycle
onMounted(() => {
  // Get log number from route params or use default
  const logNo = Array.isArray(route.params.logNo) ? route.params.logNo[0] : route.params.logNo || 'MLYHLWTXN1'
  fetchKytData(logNo)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("h4", null, "KYTs by Log Number", -1)),
                (kytData.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _cache[7] || (_cache[7] = _createTextVNode("Parent Log: ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(kytData.value.parentMainLogNo), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                onClick: refreshData,
                disabled: loading.value
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fa fa-refresh", { 'fa-spin': loading.value }])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(loading.value ? 'Loading...' : 'Refresh'), 1)
              ], 8, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "sr-only" }, "Loading...")
                  ], -1),
                  _createElementVNode("p", { class: "mt-2" }, "Loading KYTs...", -1)
                ]))]))
              : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-exclamation-triangle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(error.value), 1)
                ]))
              : _createCommentVNode("", true),
            (kytData.value && !loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _cache[11] || (_cache[11] = _createElementVNode("label", { for: "search" }, "Search KYTs", -1)),
                      _withDirectives(_createElementVNode("input", {
                        id: "search",
                        type: "text",
                        class: "form-control",
                        placeholder: "Search by site name, employee, or category...",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event))
                      }, null, 512), [
                        [_vModelText, searchTerm.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { for: "statusFilter" }, "Filter by Status", -1)),
                      _withDirectives(_createElementVNode("select", {
                        id: "statusFilter",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event))
                      }, [...(_cache[12] || (_cache[12] = [
                        _createStaticVNode("<option value=\"\" data-v-57d37220>All Status</option><option value=\"completed\" data-v-57d37220>Completed</option><option value=\"approved\" data-v-57d37220>Approved</option><option value=\"pending\" data-v-57d37220>Pending</option><option value=\"open\" data-v-57d37220>Open</option><option value=\"closed\" data-v-57d37220>Closed</option>", 6)
                      ]))], 512), [
                        [_vModelSelect, statusFilter.value]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { for: "priorityFilter" }, "Filter by Priority", -1)),
                      _withDirectives(_createElementVNode("select", {
                        id: "priorityFilter",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((priorityFilter).value = $event))
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("option", { value: "" }, "All Priority", -1),
                        _createElementVNode("option", { value: "high" }, "High", -1),
                        _createElementVNode("option", { value: "medium" }, "Medium", -1),
                        _createElementVNode("option", { value: "low" }, "Low", -1)
                      ]))], 512), [
                        [_vModelSelect, priorityFilter.value]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (kytData.value && !loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (kytData.value.parentKyt && kytData.value.parentKyt.photos && kytData.value.parentKyt.photos.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kytData.value.parentKyt.photos, (photo, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  class: "parent-photo-item",
                                  onClick: ($event: any) => (openImageModal(photo, `Parent KYT Photo ${index + 1}`))
                                }, [
                                  _createElementVNode("img", {
                                    src: photo,
                                    alt: `Parent KYT photo ${index + 1}`,
                                    class: "parent-photo-thumbnail"
                                  }, null, 8, _hoisted_25),
                                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "parent-photo-overlay" }, [
                                    _createElementVNode("i", { class: "fa fa-search-plus" })
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_26, _toDisplayString(index + 1), 1)
                                ], 8, _hoisted_24))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("h5", _hoisted_31, _toDisplayString(kytData.value.totalChildKyts), 1),
                          _cache[17] || (_cache[17] = _createElementVNode("p", { class: "card-text" }, "Total", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("h5", _hoisted_35, _toDisplayString(getCompletedKyts()), 1),
                          _cache[18] || (_cache[18] = _createElementVNode("p", { class: "card-text" }, "Completed", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("h5", _hoisted_39, _toDisplayString(getPendingKyts()), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "card-text" }, "Pending", -1))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("table", _hoisted_41, [
                      _cache[30] || (_cache[30] = _createElementVNode("thead", { class: "thead-dark" }, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { width: "10%" }, "Employee"),
                          _createElementVNode("th", { width: "8%" }, "Site UID"),
                          _createElementVNode("th", { width: "6%" }, "Previous NFD"),
                          _createElementVNode("th", { width: "6%" }, "Visited"),
                          _createElementVNode("th", { width: "6%" }, "Future NFD"),
                          _createElementVNode("th", { width: "8%" }, "Status"),
                          _createElementVNode("th", { width: "16%" }, "Category, Problem & Solution"),
                          _createElementVNode("th", { width: "10%" }, "Assignments"),
                          _createElementVNode("th", { width: "18%" }, "Penalties & Warnings"),
                          _createElementVNode("th", { width: "12%" }, "Actions")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedKyts.value, (kyt) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: kyt._id
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(kyt.categoryData, (category, catIndex) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: `${kyt._id}-${catIndex}`,
                                class: "kyt-row"
                              }, [
                                (catIndex === 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 0,
                                      rowspan: kyt.categoryData.length,
                                      class: "align-middle"
                                    }, [
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("strong", null, _toDisplayString(kyt.employee.employeeName), 1),
                                        _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                        _createElementVNode("small", _hoisted_44, _toDisplayString(kyt.employee.employeeCode), 1)
                                      ])
                                    ], 8, _hoisted_42))
                                  : _createCommentVNode("", true),
                                (catIndex === 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 1,
                                      rowspan: kyt.categoryData.length,
                                      class: "align-middle"
                                    }, [
                                      _createElementVNode("span", _hoisted_46, _toDisplayString(kyt.site.siteUID), 1)
                                    ], 8, _hoisted_45))
                                  : _createCommentVNode("", true),
                                (catIndex === 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 2,
                                      rowspan: kyt.categoryData.length,
                                      class: "align-middle"
                                    }, [
                                      _createElementVNode("small", null, _toDisplayString(kyt.previousNfd ? formatDate(kyt.previousNfd) : 'N/A'), 1)
                                    ], 8, _hoisted_47))
                                  : _createCommentVNode("", true),
                                (catIndex === 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 3,
                                      rowspan: kyt.categoryData.length,
                                      class: "align-middle"
                                    }, [
                                      _createElementVNode("small", null, _toDisplayString(formatDate(kyt.createdAt)), 1)
                                    ], 8, _hoisted_48))
                                  : _createCommentVNode("", true),
                                (catIndex === 0)
                                  ? (_openBlock(), _createElementBlock("td", {
                                      key: 4,
                                      rowspan: kyt.categoryData.length,
                                      class: "align-middle"
                                    }, [
                                      _createElementVNode("small", null, _toDisplayString(formatDate(kyt.nfd)), 1)
                                    ], 8, _hoisted_49))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["badge mb-1", getStatusBadgeClass(kyt.kytStatus)])
                                    }, _toDisplayString(getDisplayStatus(kyt.kytStatus) || 'N/A'), 3)
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                      _createElementVNode("span", _hoisted_53, _toDisplayString(category.category?.toUpperCase() || 'N/A'), 1),
                                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                                      _createElementVNode("strong", _hoisted_54, _toDisplayString(getSubCategoryName(category, kyt) || 'N/A'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _cache[22] || (_cache[22] = _createElementVNode("strong", { class: "small text-danger" }, "Problem:", -1)),
                                        _createElementVNode("p", _hoisted_57, _toDisplayString(category.problem || 'No problem description'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_58, [
                                        _cache[23] || (_cache[23] = _createElementVNode("strong", { class: "small text-success" }, "Solution:", -1)),
                                        _createElementVNode("p", _hoisted_59, _toDisplayString(category.solution || 'No solution provided'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_60, [
                                      _createElementVNode("small", _hoisted_61, "Log: " + _toDisplayString(category.logNo || 'N/A'), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_62, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.employeeAssignments, (assignment) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: assignment._id,
                                        class: "assignment-row mb-1"
                                      }, [
                                        _createElementVNode("div", _hoisted_63, [
                                          _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("small", null, [
                                              _createElementVNode("strong", null, _toDisplayString(assignment.employee.employeeName), 1),
                                              _createElementVNode("span", _hoisted_65, "(" + _toDisplayString(assignment.employee.employeeCode) + ")", 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_66, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["badge badge-xs mr-1", getPriorityBadgeClass(assignment.priority)])
                                            }, _toDisplayString(assignment.priority?.toUpperCase() || 'N/A'), 3),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["badge badge-xs mr-1", assignment.isCompletedWork ? 'badge-success' : 'badge-warning'])
                                            }, _toDisplayString(assignment.isCompletedWork ? 'DONE' : 'PENDING'), 3),
                                            (assignment.workStarted)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_67, " STARTED "))
                                              : _createCommentVNode("", true),
                                            (assignment.isVerified)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_68, " VERIFIED "))
                                              : _createCommentVNode("", true),
                                            (assignment.requiresRework)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_69, " REWORK "))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        (assignment.isCompletedWork && assignment.workCompletedAt)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                              _createElementVNode("small", _hoisted_71, [
                                                _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fa fa-check-circle" }, null, -1)),
                                                _createTextVNode(" Completed: " + _toDisplayString(formatDateTime(assignment.workCompletedAt)), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (assignment.workNotes)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                              _createElementVNode("small", _hoisted_73, [
                                                _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fa fa-sticky-note" }, null, -1)),
                                                _createTextVNode(" Notes: " + _toDisplayString(assignment.workNotes), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (assignment.photos && assignment.photos.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                              _createElementVNode("div", _hoisted_75, [
                                                _createElementVNode("small", _hoisted_76, [
                                                  _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-camera" }, null, -1)),
                                                  _createTextVNode(" Photos (" + _toDisplayString(assignment.photos.length) + "): ", 1)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_77, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assignment.photos, (photo, photoIndex) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: photoIndex,
                                                    class: "photo-thumbnail mr-1 mb-1"
                                                  }, [
                                                    _createElementVNode("img", {
                                                      src: photo,
                                                      alt: `Assignment photo ${photoIndex + 1}`,
                                                      class: "img-thumbnail",
                                                      onClick: ($event: any) => (openImageModal(photo, `Assignment ${assignment.assignmentId} - Photo ${photoIndex + 1}`))
                                                    }, null, 8, _hoisted_78)
                                                  ]))
                                                }), 128))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_79, [
                                    (category.assignedPenaltiesWarnings && category.assignedPenaltiesWarnings.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                          _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("span", _hoisted_82, _toDisplayString(category.assignedPenaltiesWarnings.length) + " Actions ", 1),
                                            (getTotalPenaltyAmount(category.assignedPenaltiesWarnings) > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, " ₹" + _toDisplayString(getTotalPenaltyAmount(category.assignedPenaltiesWarnings)), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_84, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.assignedPenaltiesWarnings.slice(0, 2), (penalty) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: penalty.employeeId + penalty.actionDate,
                                                class: "penalty-brief-item"
                                              }, [
                                                _createElementVNode("small", _hoisted_85, [
                                                  _createElementVNode("span", null, [
                                                    _createElementVNode("strong", null, _toDisplayString(penalty.employeeName), 1)
                                                  ]),
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["badge badge-xs", getActionBadgeClass(penalty.action)])
                                                  }, _toDisplayString(penalty.action?.toUpperCase()), 3)
                                                ])
                                              ]))
                                            }), 128)),
                                            (category.assignedPenaltiesWarnings.length > 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                                  _createElementVNode("small", _hoisted_87, " +" + _toDisplayString(category.assignedPenaltiesWarnings.length - 2) + " more... ", 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_88, [...(_cache[27] || (_cache[27] = [
                                          _createElementVNode("small", null, [
                                            _createElementVNode("i", { class: "fa fa-check-circle text-success" }),
                                            _createTextVNode(" No penalties ")
                                          ], -1)
                                        ]))]))
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_89, [
                                    (category.assignedPenaltiesWarnings && category.assignedPenaltiesWarnings.length > 0)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          class: "btn btn-sm btn-outline-primary",
                                          onClick: ($event: any) => (openPenaltiesModal(category)),
                                          title: `View detailed penalties with images`
                                        }, [...(_cache[28] || (_cache[28] = [
                                          _createElementVNode("i", { class: "fa fa-eye" }, null, -1),
                                          _createTextVNode(" View Details ", -1)
                                        ]))], 8, _hoisted_90))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_91, [...(_cache[29] || (_cache[29] = [
                                          _createElementVNode("small", null, "No actions", -1)
                                        ]))]))
                                  ])
                                ])
                              ]))
                            }), 128))
                          ], 64))
                        }), 128))
                      ])
                    ])
                  ]),
                  (kytData.value.pagination.totalPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _createElementVNode("nav", null, [
                          _createElementVNode("ul", _hoisted_93, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: !kytData.value.pagination.hasPrev }])
                            }, [
                              _createElementVNode("a", {
                                class: "page-link",
                                href: "#",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (changePage(kytData.value.pagination.currentPage - 1)), ["prevent"]))
                              }, "Previous")
                            ], 2),
                            _createElementVNode("li", _hoisted_94, [
                              _createElementVNode("a", _hoisted_95, _toDisplayString(kytData.value.pagination.currentPage), 1)
                            ]),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: !kytData.value.pagination.hasNext }])
                            }, [
                              _createElementVNode("a", {
                                class: "page-link",
                                href: "#",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (changePage(kytData.value.pagination.currentPage + 1)), ["prevent"]))
                              }, "Next")
                            ], 2)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (kytData.value && kytData.value.totalChildKyts === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_96, [...(_cache[31] || (_cache[31] = [
                  _createElementVNode("i", { class: "fa fa-folder-open fa-3x text-muted mb-3" }, null, -1),
                  _createElementVNode("h5", { class: "text-muted" }, "No KYTs Found", -1),
                  _createElementVNode("p", { class: "text-muted" }, "No child KYTs found for this log number.", -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (selectedImage.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "image-modal-overlay",
          onClick: closeImageModal
        }, [
          _createElementVNode("div", {
            class: "image-modal-content",
            onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("h5", _hoisted_98, _toDisplayString(selectedImageTitle.value), 1),
              _createElementVNode("button", {
                type: "button",
                class: "close",
                onClick: closeImageModal,
                "aria-label": "Close"
              }, [...(_cache[32] || (_cache[32] = [
                _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("img", {
                src: selectedImage.value,
                alt: selectedImageTitle.value,
                class: "modal-image"
              }, null, 8, _hoisted_100)
            ]),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: closeImageModal
              }, " Close "),
              _createElementVNode("a", {
                href: selectedImage.value,
                target: "_blank",
                class: "btn btn-primary ml-2"
              }, " Open in New Tab ", 8, _hoisted_102)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (selectedPenalties.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "penalties-modal-overlay",
          onClick: closePenaltiesModal
        }, [
          _createElementVNode("div", {
            class: "penalties-modal-content",
            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", { class: "penalties-modal-header" }, [
              _cache[34] || (_cache[34] = _createElementVNode("h5", { class: "modal-title" }, [
                _createElementVNode("i", { class: "fa fa-exclamation-triangle text-danger" }),
                _createTextVNode(" Category Penalties & Warnings ")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "close",
                onClick: closePenaltiesModal,
                "aria-label": "Close"
              }, [...(_cache[33] || (_cache[33] = [
                _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPenalties.value, (penalty) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: penalty.employeeId + penalty.actionDate,
                    class: "penalty-card mb-3"
                  }, [
                    _createElementVNode("div", _hoisted_105, [
                      _createElementVNode("div", _hoisted_106, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h6", _hoisted_107, [
                            _createElementVNode("strong", null, _toDisplayString(penalty.employeeName), 1)
                          ]),
                          _createElementVNode("small", _hoisted_108, [
                            _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fa fa-calendar" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(formatDate(penalty.actionDate)) + " at " + _toDisplayString(penalty.actionTime), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge mr-2", getActionBadgeClass(penalty.action)])
                          }, _toDisplayString(penalty.action?.toUpperCase() || 'N/A'), 3),
                          (penalty.penaltyAmount > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_110, " ₹" + _toDisplayString(penalty.penaltyAmount), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      (penalty.slip)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                            _cache[37] || (_cache[37] = _createElementVNode("h6", { class: "media-title" }, [
                              _createElementVNode("i", { class: "fa fa-file-text text-primary" }),
                              _createTextVNode(" Penalty Slip ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("img", {
                                  src: penalty.slip,
                                  alt: `Penalty slip for ${penalty.employeeName}`,
                                  class: "penalty-slip-image",
                                  onClick: ($event: any) => (openImageModal(penalty.slip, `Penalty Slip - ${penalty.employeeName} - ${penalty.action}`))
                                }, null, 8, _hoisted_115),
                                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "media-overlay" }, [
                                  _createElementVNode("i", { class: "fa fa-search-plus" })
                                ], -1))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (penalty.uploadPhoto)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                            _cache[39] || (_cache[39] = _createElementVNode("h6", { class: "media-title" }, [
                              _createElementVNode("i", { class: "fa fa-camera text-primary" }),
                              _createTextVNode(" Evidence Photo ")
                            ], -1)),
                            _createElementVNode("div", _hoisted_117, [
                              _createElementVNode("div", _hoisted_118, [
                                _createElementVNode("img", {
                                  src: penalty.uploadPhoto,
                                  alt: `Penalty photo for ${penalty.employeeName}`,
                                  class: "penalty-photo-image",
                                  onClick: ($event: any) => (openImageModal(penalty.uploadPhoto, `Penalty Photo - ${penalty.employeeName} - ${penalty.action}`))
                                }, null, 8, _hoisted_119),
                                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "media-overlay" }, [
                                  _createElementVNode("i", { class: "fa fa-search-plus" })
                                ], -1))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (penalty.photos && penalty.photos.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _createElementVNode("h6", _hoisted_121, [
                              _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fa fa-images text-primary" }, null, -1)),
                              _createTextVNode(" Additional Photos (" + _toDisplayString(penalty.photos.length) + ") ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_122, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(penalty.photos, (photo, photoIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: photoIndex,
                                  class: "media-item"
                                }, [
                                  _createElementVNode("img", {
                                    src: photo,
                                    alt: `Additional penalty photo ${photoIndex + 1}`,
                                    class: "penalty-photo-image",
                                    onClick: ($event: any) => (openImageModal(photo, `Additional Photo ${photoIndex + 1} - ${penalty.employeeName}`))
                                  }, null, 8, _hoisted_123),
                                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "media-overlay" }, [
                                    _createElementVNode("i", { class: "fa fa-search-plus" })
                                  ], -1))
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", { class: "penalties-modal-footer" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                onClick: closePenaltiesModal
              }, " Close ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})